import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { CurrentService } from '../../../services/current.service';
import { DatasService } from '../../../services/datas.service';
import { BymeService } from '../../../services/byme.service';
import { UserService } from 'src/app/services/user.service';
import { GTM } from 'src/app/services/gtm.service';
import { CONTEXT } from 'src/app/enum/context';

@Component({
  selector: 'ng-hbm-bdi-recap',
  templateUrl: './recap.component.html'
})
export class RecapComponent implements OnInit {

  public currentStyle;
  public currentModel;
  public currentLayout;
  public currentOvenConfiguration;
  public currentFurniture;

  @Output() onBackToStep: EventEmitter<number> = new EventEmitter();

  constructor(public current: CurrentService, public datas: DatasService, private byMe: BymeService, private customer: UserService, private gtm: GTM) { }

  async ngOnInit(): Promise<void> {
    this.gtm.trackPage(CONTEXT.KITCHEN, 'need-mapping', 'summarize', this.datas.getKitchenGtmData(this.current));

    if (this.current.styleId > 0) {
      this.currentStyle = (await this.datas.getStyles()).find(s => s.id === this.current.styleId)
    }

    if (this.current.modelId > 0) {
      this.currentModel = (await this.datas.getModels()).find(m => m.id === this.current.modelId)
    }

    if (this.current.layoutRef) {
      this.currentLayout = (await this.datas.getLayouts()).find(l => l.id === this.current.layoutRef)
    }

    if (this.current.ovenConfigurationRef) {
      this.currentOvenConfiguration = (await this.datas.getOvenConfigurations()).find(oc => oc.id === this.current.ovenConfigurationRef)
    }

    if (this.current.furnitureConfiguration) {
      this.currentFurniture = (await this.datas.getFurnitures()).find(fc => fc.id === this.current.furnitureConfiguration)
    }
  }

  backToStep(step: number) {
    this.onBackToStep.emit(step);
  }

  start() {
    this.gtm.trackEvent('click', 'need-mapping-' + CONTEXT.KITCHEN, 'start', this.datas.getKitchenGtmData(this.current));
    if (this.customer.userDatas) {
      if (this.customer.userDatas.vendor && !this.customer.userDatas.otherAccount) {
        this.byMe.byMeApiToken = null;
      }
    }
    
    this.byMe.prepareBymeSettings(
      this.current.modelId,
      this.current.layoutRef,
      this.current.ovenConfigurationRef,
      this.current.furnitureConfiguration
    )
  }
}
